import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import Cookies from "js-cookie";
import { setStatusFail } from "../statusFail/statusFailSlice";

const initialState = {
  tenant: {},
  loading: false,
  error: null,
};

const ACCOUNTS_URL = process.env.REACT_APP_ACCOUNTS_URL;

// export const updateTenant = createAsyncThunk(
//   "tenant/updateTenant",
//   async ({ data }, { rejectWithValue }) => {
//     const id = Cookies.get("TenantId");
//     console.log(data, "in update tenants");

//     try {
//       const response = await axios.patch(
//         `${ACCOUNTS_URL}/tenants/${id}`,
//         data,
//         {
//           headers: {
//             Authorization: `Bearer ${Cookies.get("Token")}`,
//           },
//         }
//       );

//       console.log("Response from server:", response.data);

//       return response.data;
//     } catch (error) {
//       return rejectWithValue(error.response.data);
//     }
//   }
// );

export const updateTenant = createAsyncThunk(
  "tenant/updateTenant",
  async ({ data }, { rejectWithValue,dispatch }) => {
    const id = Cookies.get("TenantId");
    try {
      const response = await axios.patch(
        `${ACCOUNTS_URL}/tenants/${id}`,
        data,
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("Token")}`,
          },
        }
      );
      return response.data.data;
    } catch (error) {
      if(error.response?.data?.errorCode == "STATUS_CHECK_TENANT_DENIED"){
              const route = "/status-failed"
              await dispatch(setStatusFail({tenants:error.response.data.tenants,navigate:route}))
            }
      return rejectWithValue(error.response.data?.error?.message || "Something went wrong");
    }
  }
);

export const getTenant = createAsyncThunk(
  "tenant/getTenant",
  async (_, { rejectWithValue,dispatch }) => {
    const id = Cookies.get("TenantId");
    try {
      const response = await axios.get(
        `${ACCOUNTS_URL}/tenants/tenant/${id}`,
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("Token")}`,
          },
        }
      );
      
      return response.data.data;
    } catch (error) {
      if(error.response?.data?.errorCode == "STATUS_CHECK_TENANT_DENIED"){
        const route = "/status-failed"
        await dispatch(setStatusFail({tenants:error.response.data.tenants,navigate:route}))
      }
      return rejectWithValue(error.response.data?.error?.message || "Something went wrong");
    }
  }
);

export const updateRole = createAsyncThunk(
  "tenant/updateRole",
  async ({ tenantId, roleId, data }, { rejectWithValue,dispatch }) => {
    try {
      const response = await axios.patch(
        `${ACCOUNTS_URL}/tenants/role-update/${tenantId}/${roleId}`,
        data,
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("Token")}`,
            "Content-Type": "application/json",
          },
        }
      );
 
      return response.data.data;
    } catch (error) {
      if(error.response?.data?.errorCode == "STATUS_CHECK_TENANT_DENIED"){
        const route = "/status-failed"
        await dispatch(setStatusFail({tenants:error.response.data.tenants,navigate:route}))
      }
      return rejectWithValue(error.response.data?.error?.message || "Something went wrong");
    }
  }
);
export const deleteRole = createAsyncThunk(
  "tenant/deleteRole",
  async ({ tenantId, roleId }, { rejectWithValue ,dispatch}) => {
    try {
      const response = await axios.delete(
        `${ACCOUNTS_URL}/tenants/role-delete/${tenantId}/${roleId}`,
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("Token")}`,
          },
        }
      );
  
      return { roleId };
    } catch (error) {
      if(error.response.data.errorCode == "STATUS_CHECK_TENANT_DENIED"){
        const route = "/status-failed"
        await dispatch(setStatusFail({tenants:error.response.data.tenants,navigate:route}))
      }
      return rejectWithValue(error.response.data);
    }
  }
);


const rolesSlice = createSlice({
  name: "tenant",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(updateTenant.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateTenant.fulfilled, (state, action) => {
        state.loading = false;
        state.tenant = action.payload;
      })
      .addCase(updateTenant.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getTenant.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getTenant.fulfilled, (state, action) => {
        state.loading = false;
        state.tenant = action.payload;
      })
      .addCase(getTenant.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateRole.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateRole.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateRole.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      }).addCase(deleteRole.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteRole.fulfilled, (state, action) => {
        state.loading = false;
        state.roles = state.roles.filter((role) => role.id !== action.payload);
      })
      .addCase(deleteRole.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

  },
});

export default rolesSlice.reducer;
